import React from 'react';

import { STORAGE_KEYS } from 'constants/storage';
import { Alert } from '../../alert';
import STRINGS from 'constants/strings';
import InfoIcon from '@tradera/blueprint/theme/icons/info.svg?jsx';
import CheckIcon from '@tradera/blueprint/theme/icons/check.svg?jsx';
import './cookies.scss';

const Cookies = () => {
    return (
        <Alert
            dismissible
            zIndex={20}
            classNames="cookie-alert position-fixed alert-light alert-dismissible mb-0 mx-sm-auto mx-3 fade rounded-0 p-4 p-md-5 border border-primary"
            storageKey={STORAGE_KEYS.COOKIE_NOTIFICATION}
            name="Cookies"
            render={dismiss => (
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-1">
                            <InfoIcon className="icon icon-lg icon-dark" />
                        </div>
                        <div className="col-11 d-flex flex-wrap h6 font-weight-bold pl-4">
                            {STRINGS.COOKIES.HEADER}
                        </div>
                        <div className="col-10 offset-1 my-3 pl-4 px-md-4">
                            <div className="border-bottom" />
                        </div>
                        <div className="col-10 offset-1 d-flex flex-wrap pl-4">
                            {STRINGS.COOKIES.DESC + ' '}
                            <a
                                className="text-primary pt-3"
                                href="http://info.tradera.com/sakerhetscenter/cookies/">
                                {STRINGS.COOKIES.READ_MORE}
                            </a>
                        </div>
                        <div className="col-10 offset-1 d-flex pt-4 justify-content-md-start justify-content-center pl-4">
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={e => dismiss(e)}>
                                <CheckIcon className="icon icon-before " />
                                {STRINGS.I_UNDERSTAND}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        />
    );
};

export default Cookies;
